// BackgroundImage.js

import React from 'react';
import delaPunkImg from '../public/assets/dela-punk-fullbody.webp'; 

function BackgroundImage() {
    return <img className="background-image" src={delaPunkImg} alt="full body illustration of a punk husky fursona with spiked hair"/>;
}

export default BackgroundImage;